import { sharedEndpoints } from 'shared-helpers';

export const API_URL_NEW       = sharedEndpoints.API_URL_NEW;
export const SSR_API_URL_NEW = sharedEndpoints.SSR_API_URL_NEW;
export const SHARED_WEB_URL    = sharedEndpoints.SHARED_WEB_URL
export const WEB_URL           = sharedEndpoints.WEB_URL
export const IMG_PATH          = sharedEndpoints.SHARED_WEB_URL
export const LOGGER_URL        = sharedEndpoints.LOGGER_URL;
export const PUBLIC_IMG_URL    = sharedEndpoints.PUBLIC_IMG_URL;

// dev test
// export const API_URL_NEW = "https://api.magnitt.com"; 
// export const SHARED_WEB_URL = "http://localhost:4000";
// export const API_URL_NEW    = 'http://localhost:3212/core-api';
// export const SSR_API_URL_NEW = 'https://gateway.magnitt.com/core-api';